import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomSelect from "components/Common/custom-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";

const departmentOptions = [
  { label: "Admin", value: "Admin" },
  { label: "CUTTING", value: "CUTTING" },
  { label: "PRODUCTION", value: "PRODUCTION" },
  { label: "PACKING", value: "PACKING" },
  { label: "ANCILLARY", value: "ANCILLARY" },
  { label: "HR", value: "HR" },
  { label: "STORE", value: "STORE" },
  { label: "QUALITY CONTROL", value: "QUALITY CONTROL" },
  { label: "EMBROIDERY", value: "EMBROIDERY" },
];

const categoryOptions = [
  { label: "Staff", value: "Staff" },
  { label: "Worker", value: "Worker" },
];

const AttendanceReportLateComers = () => {
  const formik = useFormik({
    initialValues: {
      department: "",
      category: "",
      code: "",
      name: "",
      fromDate: "",
      toDate: "",
      withoutGrace: false,
    },
    validationSchema: Yup.object({
      fromDate: Yup.string().required("From Date is required"),
      toDate: Yup.string().required("To Date is required"),
    }),
    onSubmit: (values) => {
      console.log("Submitted values:", values);
    },
  });

  const [data] = useState([
    {
      code: "001",
      department: "QUALITY CONTROL",
      name: "ARUN",
      shiftTime: "06:00-14:00",
      date: "01.06.24",
      actual: "06:00",
      in: "06:20",
      late: "00:20",
    },
    {
      code: "001",
      department: "QUALITY CONTROL",
      name: "ARUN",
      shiftTime: "06:00-14:00",
      date: "07.08.24",
      actual: "06:00",
      in: "14:00",
      late: "08:00",
    },
    {
      code: "002",
      department: "PRODUCTION",
      name: "VIGNESH",
      shiftTime: "14:00-22:00",
      date: "04.03.24",
      actual: "14:00",
      in: "16:00",
      late: "02:00",
    },
  ]);

  const columns = [
    { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
    { Header: "Code", accessor: "code" },
    { Header: "Department", accessor: "department" },
    { Header: "Name", accessor: "name" },
    { Header: "Shift Time", accessor: "shiftTime" },
    { Header: "Date", accessor: "date" },
    { Header: "Actual", accessor: "actual" },
    { Header: "In", accessor: "in" },
    { Header: "Late", accessor: "late" },
  ];

  return (
    <div className="page-content">
      <Container fluid>
          <Breadcrumbs title="Attendance" breadcrumbItem="Late Comers List" />

        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3 ">
                <Col md={4}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={(val) => formik.setFieldValue("department", val)}
                    options={[{ label: "--Select--", value: "" }, ...departmentOptions]}
                  />
                </Col>

                <Col md={4}>
                  <Label>Category</Label>
                  <CustomSelect
                    name="category"
                    value={formik.values.category}
                    onChange={(val) => formik.setFieldValue("category", val)}
                    options={[{ label: "--Select--", value: "" }, ...categoryOptions]}
                  />
                </Col>

                <Col md={4}>
                  <Label>Code</Label>
                  <Input
                    type="text"
                    name="code"
                    value={formik.values.code}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>

                <Col md={4}>
                  <Label>Name</Label>
                  <Input
                    type="text"
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>

                <Col md={4}>
                  <Label>
                    From Date <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="fromDate"
                    value={formik.values.fromDate}
                    onChange={(val) => formik.setFieldValue("fromDate", val)}
                    onBlur={() => formik.setFieldTouched("fromDate", true)}
                  />
                  {formik.touched.fromDate && formik.errors.fromDate && (
                    <div className="text-danger">{formik.errors.fromDate}</div>
                  )}
                </Col>

                <Col md={4}>
                  <Label>
                    To Date <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="toDate"
                    value={formik.values.toDate}
                    onChange={(val) => formik.setFieldValue("toDate", val)}
                    onBlur={() => formik.setFieldTouched("toDate", true)}
                  />
                  {formik.touched.toDate && formik.errors.toDate && (
                    <div className="text-danger">{formik.errors.toDate}</div>
                  )}
                </Col>

                <Col md={4} className="d-flex align-items-center">
                  <Input
                    id="withoutGrace"
                    type="checkbox"
                    className="me-2"
                    checked={formik.values.withoutGrace}
                    onChange={(e) =>
                      formik.setFieldValue("withoutGrace", e.target.checked)
                    }
                  />
                  <Label htmlFor="withoutGrace" className="mb-0">
                    Without Grace Time
                  </Label>
                </Col>

                <Col md={12} className="text-end">
                  <Button type="submit" className="btn button-search me-2 mt-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-print mt-2">
                    <i className="fas fa-print me-1" /> Print
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportLateComers;
